
import React from 'react';
import { 
  RefreshCw,
  PlusCircle,
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useEmail } from '@/context/EmailContext';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import { ScrollArea } from '@/components/ui/scroll-area';
import EmailNavigation from './EmailNavigation';

interface EmailSidebarProps {
  className?: string;
  onCompose?: () => void;
  onClose?: () => void;
}

const EmailSidebar: React.FC<EmailSidebarProps> = ({ 
  className, 
  onCompose,
  onClose
}) => {
  const { syncWithServer, refreshEmails, loading } = useEmail();
  const isMobile = useIsMobile();
  
  return (
    <div className={cn(
      "flex items-center gap-4",
      !isMobile && "py-1",
      className
    )}>
      {isMobile && (
        <Button 
          onClick={() => {
            onCompose?.();
            if (isMobile && onClose) {
              onClose();
            }
          }}
          className="w-full gap-2 mb-2"
        >
          <PlusCircle className="h-4 w-4" />
          <span>Compose</span>
        </Button>
      )}
      
      {isMobile && (
        <Button 
          variant="outline" 
          className="w-full gap-2 mb-2"
          onClick={async () => {
            // NOTE: pass no argument — onClick would otherwise forward the
            // MouseEvent as syncWithServer's accountId parameter.
            try {
              await syncWithServer();
              await refreshEmails();
            } catch (error) {
              console.error('💥 Sync failed:', error);
            }
          }}
          disabled={loading}
        >
          <RefreshCw className={cn("h-4 w-4", loading && "animate-spin")} />
          <span>Sync Emails</span>
        </Button>
      )}
      
      <div className="flex-1">
        <EmailNavigation 
          onItemClick={() => {
            if (isMobile && onClose) {
              onClose();
            }
          }} 
        />
      </div>
    </div>
  );
};

export default EmailSidebar;
